import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { debounce } from "lodash";
import { observer } from "mobx-react";
import SwipeableViews from "react-swipeable-views";
import { virtualize } from "react-swipeable-views-utils";

import { useStore } from "../../store";
import DetailItem from "./DetailItem";
import firebaseEvent from "../../utils/firebaseEvent";

const EnhancedSwipeableViews = virtualize(SwipeableViews);

const DetailList = () => {
  const history = useHistory();
  const { id } = useParams<{ id: string }>();
  const {
    appStore: { apiHeaderState },
    detailStore: {
      detailState: { list },
      onUpdateDetailList,
    },
  } = useStore();

  // id 없는 경우 feeds로 이동
  if (!id) {
    history.replace("/feeds");
    return null;
  }

  const projects = list.map((project) => project.projectId);
  const activeIndex = projects.indexOf(id);

  const slideRenderer = ({ _, index }: any) => {
    // mobx 갱신 전 list 값 참조 시 없는 경우 Null 반환
    if (!list[index]) return null;
    if (index === list.length - 1) {
      debounce(() => onUpdateDetailList(apiHeaderState), 300)();
    }
    return <DetailItem key={index} projectId={list[index].projectId} />;
  };

  const onChangeIndex = (index: number) => {
    const direction = index > activeIndex ? "left" : "right";
    const jsonParams = {
      P1: list[activeIndex]?.projectId,
      P2: list[index]?.projectId,
      P3: direction,
    };
    firebaseEvent("detail_swipe", jsonParams);
    history.replace(`/detail/${list[index].projectId}`);
  };

  if (activeIndex === -1) {
    return <DetailItem projectId={id} />;
  }
  return (
    <EnhancedSwipeableViews
      index={activeIndex}
      onChangeIndex={onChangeIndex}
      slideRenderer={slideRenderer}
      slideCount={list.length}
      overscanSlideBefore={1}
      overscanSlideAfter={1}
      enableMouseEvents
    />
  );
};

export default observer(DetailList);
